import { type Cluster } from '@/packages/query-state/shared/types/clusters/ClustersResponse';

export const parseClusterCount = (cluster: Cluster): number | undefined => {
  const count = cluster.properties?.counter;

  if (!count) {
    return undefined;
  }

  return Number(count.replace('+', ''));
};
